import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import {
  getHelpCardTitle,
} from 'common/helpCardHelpers';

import {
  hasRoleLandlord,
  hasRoleAdmin,
} from 'common/userRoles';
import {
  getListingApplyURL,
} from 'common/listingHelpers';

import {
  MEDIA_QUERY_SMALL_SCREEN,
} from 'client/constants/mediaQueries';

import useBranch from 'client/hooks/useBranch';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrLinkUrlButton from 'client/components/SrLinkUrlButton';
import SrPartnerPageFooter from 'client/components/SrPartnerPageFooter';
import SrPartnerListingHeader from 'client/components/SrPartnerListingHeader';
import SrHelpCardSection from 'client/components/SrHelpCardSection/SrHelpCardSection';
import SrPrequalificationsSection from 'client/components/SrPrequalificationsSection';
import SrPartnerContactSupportModal from 'client/components/SrPartnerContactSupportModal';
import SrListingTenantScreeningApplyLinkModal from 'client/components/SrListingTenantScreeningApplyLinkModal';
import SrPartnerListingPageArchiveListing from 'client/components/SrPartnerListingPage/SrPartnerListingPageArchiveListing';
import SrPartnerListingPageTenantScreeningHouseholdsApplying from 'client/components/SrPartnerListingPage/SrPartnerListingPageTenantScreeningHouseholdsApplying';
import SrPartnerListingPageTenantScreeningHouseholdsStartedApplying from 'client/components/SrPartnerListingPage/SrPartnerListingPageTenantScreeningHouseholdsStartedApplying';
import SrAdminListingNotes from 'client/components/SrAdminListingNotes';
import SrCard, {
  SR_CARD_BULLET_COLOR_BLUE,
} from 'client/components/SrCard/SrCard';

const SrPartnerListingPageListingTenantScreening = ({
  listing,
  prequalifications,
  match,
  history,
  location,
  dispatch,
  householdsApplying,
  helpCards,
  reloadPartnerListing,
  householdsStartedApplying,
}) => {
  const {
    appUrl,
    currentUser,
    currentPartnerUser,
    partnersBySlug,
  } = useBranch({
    appUrl: ['env', 'APP_URL'],
    currentUser: ['currentUser'],
    currentPartnerUser: ['partners', 'currentPartnerUser'],
    partnersBySlug: ['partners', 'bySlug'],
    listingLinksByListingId: ['listingLinksByListingId'],
  });
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isSupportLinksModalOpen, setIsSupportLinksModalOpen] = useState(false);
  const currentPartner = partnersBySlug[match.params.partnerSlug];
  const isAdmin = hasRoleAdmin(currentUser.roles);
  const isLandlord = hasRoleLandlord(currentUser.roles);
  const applyUrl = getListingApplyURL(listing, appUrl);

  useEffect(() => {
    if (location.search.includes('source=createListing')) {
      setIsShareModalOpen(true);
    }
  }, [location]);

  return (
    <div>
      <SrPartnerListingHeader
        listing={listing}
        currentUser={currentUser}
        currentPartnerUser={currentPartnerUser}
        currentPartner={currentPartner}
        onOpenListingLinksClick={() => {}}
        onOpenShareListingClick={() => setIsShareModalOpen(true)}
        onOpenSupportLinksClick={() => setIsSupportLinksModalOpen(true)}
        partnerSlug={match.params.partnerSlug}
        isLandlord={isLandlord}
        dispatch={dispatch}
        onLowerRentPrice={reloadPartnerListing}
      />
      <SrBox margin='55px auto 0' padding='0 10px' maxWidth='1180px'>
        {isAdmin &&
          <SrBox marginTop='50px'>
            <SrCard
              header='Notes (Admin-Only)'
              color={SR_CARD_BULLET_COLOR_BLUE}
              maxWidth='none'
            >
              <SrAdminListingNotes
                listingId={listing.id}
                dispatch={dispatch}
                currentUser={currentUser}
              />
            </SrCard>
          </SrBox>
        }
        <SrBox
          backgroundColor='white'
          marginTop='50px'
          padding='40px 24px'
          borderRadius='14px'
        >
          <SrFlex align='center' justify='center' direction={!isSmallScreen ? 'row' : 'col'}>
            <SrBox marginRight='16px'>
              <img width='40px' height='auto' src='/images/share-link-blue.png' alt='share' />
            </SrBox>
            <SrText
              color='blue'
              font='greycliff'
              weight='800'
              fontSize='26px'
              lineHeight='33px'
              display='block'
              align='center'
            >
              Please forward this link to all Applicants & Guarantors!
            </SrText>
          </SrFlex>
          <SrBox marginTop='33px' width='100%'>
            <SrLinkUrlButton href={applyUrl} className='linkUrlButtonBottom' />
          </SrBox>
        </SrBox>
        {householdsApplying && (
          <div
            className='HouseholdsApplyingSection'
            style={{
              scrollMargin: '50px',
            }}
          >
            <SrPartnerListingPageTenantScreeningHouseholdsApplying
              partner={currentPartner}
              listingId={listing.id}
              householdsApplying={householdsApplying}
              appUrl={appUrl}
              history={history}
              dispatch={dispatch}
              currentUser={currentUser}
              location={location}
            />
          </div>
        )}
        {householdsStartedApplying && (
          <div
            className='HouseholdsStatedApplyingSection'
            style={{
              scrollMargin: '50px',
            }}
          >
            <SrPartnerListingPageTenantScreeningHouseholdsStartedApplying
              partner={currentPartner}
              listingId={listing.id}
              householdsApplying={householdsStartedApplying}
              appUrl={appUrl}
              history={history}
              dispatch={dispatch}
              currentUser={currentUser}
              location={location}
            />
          </div>
        )}
        {
          prequalifications?.length > 0 && (
            <SrPrequalificationsSection
              prequalifications={prequalifications}
            />
          )
        }
        <SrPartnerListingPageArchiveListing
          listing={listing}
          dispatch={dispatch}
          reloadPartnerListing={reloadPartnerListing}
        />
        {helpCards && helpCards.length > 0 && (
          <SrBox marginTop='80px'>
            <SrHelpCardSection
              helpCards={helpCards}
              title={getHelpCardTitle({ partner: currentPartner })}
            />
          </SrBox>
        )}
        <SrPartnerPageFooter />
      </SrBox>
      {isShareModalOpen && (
        <SrListingTenantScreeningApplyLinkModal
          listing={listing}
          onClose={() => setIsShareModalOpen(false)}
        />
      )}
      {isSupportLinksModalOpen && (
        <SrPartnerContactSupportModal
          onClose={() => setIsSupportLinksModalOpen(false)}
        />
      )}
    </div>
  );
};

SrPartnerListingPageListingTenantScreening.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  listing: PropTypes.object,
  prequalifications: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  householdsApplying: PropTypes.object,
  householdsStartedApplying: PropTypes.object,
  reloadPartnerListing: PropTypes.func.isRequired,
  helpCards: PropTypes.array,
};

SrPartnerListingPageListingTenantScreening.displayName = 'SrPartnerListingPageListingTenantScreening';

export default SrPartnerListingPageListingTenantScreening;
